import { EnviromentDataModel } from './EnviromentModel'

interface CardAlert {
  message_code?: string
  alerted_at?: any
}

interface DripNavi {
  created_at: string
  error_message: string
  device_type: string
  battery: string
  flow: string
  mode: string
  remaining_qty: number
  time: number
  user_id: number
}

export default class UserModel {
  /* tslint:disable:variable-name */
  public _id: string = ''
  public name: string = ''
  public user_id: string = ''
  public mobile_username: string = ''
  public card_id: string = ''
  public card_type: string = ''
  public jcard_type: string = 'jcard' // jcard | smart_card
  public category_id: string = ''
  public category_name: string = ''
  public category_color: string = ''
  public user_type: string = 'people' // people | things
  public nearest_card_id: string = ''
  public nearest_beacon_id: string = ''
  public beacon_id: string = ''
  public beacon_type: string = ''
  public current_location_name: string = ''
  public unknown_device?: boolean
  public rssi?: number = 0
  public major: string = ''
  public minor: string = ''
  public san_id: string = ''
  public lat: number = 0
  public lon: number = 0

  public beacon_alert: CardAlert = {} as any
  public loc_alert: CardAlert = {} as any

  public battery_level: number = 0
  public current_floor_id: string = ''
  public measureded_at: string | Date = ''
  public is_outside: boolean = false

  // status of geofence
  public geo_status: boolean = false
  public geo_name?: string
  public geo_ids?: any
  public geo_bg_class?: string

  // Alert message from navi
  public error_message?: string = ''

  public created_at: Date = new Date()
  public updated_at: Date = new Date()

  public dripnavi_data: DripNavi = {} as any

  // enviroment Info
  public enviroment_data?: EnviromentDataModel
}
